export default {
  "bbt.footer.eventProgram": "",
  "bbt.footer.news": "",
  "bbt.footer.report": "",
  "bbt.footer.supporter": "",
  "bbt.footer.about": "",
  "bbt.footer.contact": "",
  "bbt.footer.footerLinks": "",
} as const;
